import {Component} from "@angular/core";
import {provideReportModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {OptInMarketingSearchModel} from "../opt-in-marketing-search.model";
import {OptInMarketingReportModel} from "../../reports/opt-in-marketing/opt-in-marketing-report-model.service";

@Component({
    selector: "wbo-opt-in-marketing-search-page",
    templateUrl: "./opt-in-marketing-search-page.component.html",
    providers: [provideSearchModel(OptInMarketingSearchModel), provideReportModel(OptInMarketingReportModel)]
})
export class OptInMarketingSearchPageComponent extends AbstractSearchPage {

    constructor(private optInMarketingReportModel: OptInMarketingReportModel) {
        super();
    }

    export(): void {
        if (!this.searchPageComponent.reportGenerationService.running) {
            this.searchPageComponent.reportGenerationService.execute(this.optInMarketingReportModel);
        }
    }
}
